import { httpClient } from '../utilities/httpClient'
export const sendInquiry = ({ data: { emailType, ...data }, onSuccess, onError }) => async () => {
    try {
        const response = await httpClient.post(`/email/send/${emailType}`, data, { timeout: 25000 })
        if (typeof window.gtag === "function") {
            window.gtag('event', 'page_view', {
                'send_to': 'AW-16691891184',
                'value': 'replace with value',
                'items': [{
                    'id': 'replace with value',
                    'location_id': 'replace with value',
                    'google_business_vertical': 'custom'
                }]
            })
        }
        if (onSuccess) onSuccess(response?.data)
    } catch (error) {
        if (onError) onError(error)
    }
}